import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import VideoSection from "@/components/VideoSection";
import CoreValues from "@/components/CoreValues";
import ProjectsSection from "@/components/ProjectsSection";
import JoinSection from "@/components/JoinSection";
import { useAuth } from "@/context/AuthContext";

export default function Home() {
  const [params] = useSearchParams();
  const { openAuth, user, ready } = useAuth();

  useEffect(() => {
    const ref = params.get("ref");
    if (ready && ref && !user) {
      openAuth({ inviteCode: ref.toUpperCase() });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready]);

  return (
    <main>
      <Hero />
      <Marquee />
      <VideoSection />
      <CoreValues />
      <ProjectsSection />
      <JoinSection />
    </main>
  );
}
